import React from "react";

import YourFields from "./GroupMapping";
import CalendarMapping from "./CalendarMapping";
import AssetsMapping from "./AssetsMapping";

function Mapping() {
  return ( 
    <div className="mb-5 mt-3 m-5">
      <YourFields />
      <CalendarMapping />
      <AssetsMapping/>
    </div>
  );
}

export default Mapping;
